import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "menu", "checkbox", "label"]
  static values = { selected: Array }

  connect() {
    this._onOutsideClick = this._onOutsideClick.bind(this)
    const selectedIds = this.selectedValue.map(String)
    this.checkboxTargets.forEach(cb => {
      if (selectedIds.includes(cb.value)) cb.checked = true
    })
    this.updateLabel()
  }

  toggle(event) {
    event.stopPropagation()
    if (this.menuTarget.classList.contains("hidden")) {
      this.menuTarget.classList.remove("hidden")
      setTimeout(() => document.addEventListener("click", this._onOutsideClick), 0)
    } else {
      this._close()
    }
  }

  updateLabel() {
    const checked = this.checkboxTargets.filter(cb => cb.checked)
    if (checked.length === 0) {
      this.labelTarget.textContent = "Selecionar participantes"
    } else if (checked.length === 1) {
      this.labelTarget.textContent = checked[0].closest("label").querySelector(".label-text").textContent.trim()
    } else {
      this.labelTarget.textContent = `${checked.length} participantes`
    }
  }

  _onOutsideClick(event) {
    if (!this.element.contains(event.target)) this._close()
  }

  _close() {
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this._onOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this._onOutsideClick)
  }
}
